export default __webpack_public_path__ + "img/dSaTQEoc.4ad46656.svg";